import BaseValidator from 'services/validations/base-validator';

class UniqueCompetitionValidator extends BaseValidator {
    private errorMessage = 'Competitions have to be unique.';

    public setErrorMessage(errorMessage): void {
        this.errorMessage = errorMessage;
    }

    protected runValidation(): void {
        if (!this.isCompetitionsUnique()) {
            this.addCompetitionNonUniqueError();
        }
    }

    private isCompetitionsUnique(): boolean {
        // @ts-ignore
        const {stacking} = this.dependencies;
        const items = stacking.getItems();

        const competitionIds = [];
        for (let item of Object.values(items)) {
            // @ts-ignore
            if (!item.getCompetitionId()) {
                continue;
            }
            // @ts-ignore
            if (inArray(item.getCompetitionId(), competitionIds)) {
                return false;
            }
            // @ts-ignore
            competitionIds.push(item.getCompetitionId());
        }

        return true;
    }

    private addCompetitionNonUniqueError(): void {
        const {errorMessage} = this;

        this.addError(errorMessage);
    }
}

export default UniqueCompetitionValidator;
